// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import type CalendarIcons from './CalendarIcons';

export type CalendarIconsSubset = { [icon in CalendarIcons]: string };

export let CalendarIconsDefinitions: CalendarIconsSubset = {
    AddField: '\ue4c7',
    AddTo: '\uecc8',
    Articles: '\ueac1',
    Balloons: '\ued7e',
    Cafe: '\uec32',
    Cake: '\ueca4',
    CalendarDay: '\ue8bf',
    CalendarWeek: '\ue8c0',
    CalendarWorkWeek: '\uef51',
    CaretLeft8: '\uedd5',
    CaretRight8: '\uedd6',
    Cat: '\ued7f',
    Chart: '\ue999',
    ChevronDownSmall: '\ue96e',
    FilterSolid: '\uf412',
    GlobeFavorite: '\uef53',
    HomeSolid: '\uea8a',
    Hospital: '\ue91d',
    Library: '\ue8f1',
    MailReminder: '\uf418',
    MoreSports: '\ueb22',
    MusicInCollectionFill: '\uea36',
    OpenFile: '\ue8e5',
    Pill: '\ueacb',
    Product: '\uecdc',
    ResponsesMenu: '\uf768',
    Separator: '\uf35e',
    Shop: '\ue719',
    Split: '\uedbc',
    Suitcase: '\uedd3',
    Trophy: '\ued3f',
    UserOptional: '\uf767',
    Website: '\ueb41',
    WindowEdit: '\uf50e',
    Work: '\ue821',
};

export default {
    fontFileName: 'calendarIcons',
    icons: CalendarIconsDefinitions,
};
